import {
  SelectOverrides,
  SelectProps as RawSelectProps,
  Select as RawSelect,
} from 'baseui/select';
import stylesColors from 'common/styles/styles.colors';
import * as React from 'react';

import { styles } from '../styles';

const overridesStyle: ({
  overrides,
  disabled,
  maxWidth,
}: {
  overrides;
  disabled;
  maxWidth?: number;
}) => SelectOverrides = ({ overrides, disabled, maxWidth }) => ({
  ...(disabled
    ? {
        Input: {
          component: () => null,
          style: styles.reset,
        },
        IconsContainer: {
          component: () => null,
          style: styles.reset,
        },
        ControlContainer: {
          // component: () => null,
          style: styles.reset,
        },
      }
    : {
        ControlContainer: {
          style: styles.active,
        },
      }),
  Popover: {
    props: {
      overrides: {
        Body: {
          style: {
            zIndex: 1000,
          },
        },
      },
    },
  },
  Placeholder: {
    style: {
      color: `${stylesColors.skyLight} !important`,
      '-webkit-text-fill-color': `${stylesColors.skyLight} !important`,
    },
  },
  Root: {
    style: {
      minWidth: '168px',
      maxWidth: maxWidth ? `${maxWidth}px` : undefined,
    },
  },
  ValueContainer: {
    style: {
      paddingTop: '2px',
      paddingBottom: '2px',
    },
  },
  Tag: {
    props: {
      closeable: !disabled,
      overrides: {
        Root: {
          style: ({ $theme }) => ({
            backgroundColor: $theme.colors.primaryDark,
            borderColor: $theme.colors.primaryDark,
            color: 'white',
          }),
        },
      },
    },
  },
  ...overrides,
});

interface SelectProps extends RawSelectProps {
  maxWidth?: number;
}

export default function Select(props: SelectProps) {
  const { disabled, overrides, maxWidth, ...rest } = props;

  return (
    <RawSelect
      {...rest}
      disabled={disabled}
      overrides={overridesStyle({ overrides, disabled, maxWidth })}
    />
  );
}
